import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { StepperRootEmits, StepperRootProps } from 'reka-ui'
import { cn } from '@/lib/utils'
import { StepperRoot, useForwardPropsEmits } from 'reka-ui'

import { computed, type HTMLAttributes } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Stepper',
  props: {
    defaultValue: {},
    orientation: {},
    dir: {},
    modelValue: {},
    linear: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})

const forwarded = useForwardPropsEmits(delegatedProps, emits)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(StepperRoot), _mergeProps({
    class: _unref(cn)(
      'flex gap-2',
      props.class,
    )
  }, _unref(forwarded)), {
    default: _withCtx((slotProps) => [
      _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps(slotProps)))
    ]),
    _: 3
  }, 16, ["class"]))
}
}

})